<template>
  <canvas ref="graph"></canvas>
</template>

<script>
  import Chart from 'chart.js';
  export default {
    props: ['ultimosRequests', 'mensal'],
    data() {
      return {
        ctx: null,
        chart: null,
      }
    },
    mounted() {
      this.ctx = this.$refs.graph.getContext('2d');

      let max = 0;

      this.ultimosRequests.forEach(function (item) {
        if (item > max) {
          max = item;
        }
      });

      let labels = []

      if (this.mensal == true) {
          labels = [
            moment().subtract(30, 'days').format('DD/MMM'),
            moment().subtract(29, 'days').format('DD/MMM'),
            moment().subtract(28, 'days').format('DD/MMM'),
            moment().subtract(27, 'days').format('DD/MMM'),
            moment().subtract(26, 'days').format('DD/MMM'),
            moment().subtract(25, 'days').format('DD/MMM'),
            moment().subtract(24, 'days').format('DD/MMM'),
            moment().subtract(23, 'days').format('DD/MMM'),
            moment().subtract(22, 'days').format('DD/MMM'),
            moment().subtract(21, 'days').format('DD/MMM'),
            moment().subtract(20, 'days').format('DD/MMM'),
            moment().subtract(19, 'days').format('DD/MMM'),
            moment().subtract(18, 'days').format('DD/MMM'),
            moment().subtract(17, 'days').format('DD/MMM'),
            moment().subtract(16, 'days').format('DD/MMM'),
            moment().subtract(15, 'days').format('DD/MMM'),
            moment().subtract(14, 'days').format('DD/MMM'),
            moment().subtract(13, 'days').format('DD/MMM'),
            moment().subtract(12, 'days').format('DD/MMM'),
            moment().subtract(11, 'days').format('DD/MMM'),
            moment().subtract(10, 'days').format('DD/MMM'),
            moment().subtract(9, 'days').format('DD/MMM'),
            moment().subtract(8, 'days').format('DD/MMM'),
            moment().subtract(7, 'days').format('DD/MMM'),
            moment().subtract(6, 'days').format('DD/MMM'),
            moment().subtract(5, 'days').format('DD/MMM'),
            moment().subtract(4, 'days').format('DD/MMM'),
            moment().subtract(3, 'days').format('DD/MMM'),
            moment().subtract(2, 'days').format('DD/MMM'),
            moment().subtract(1, 'days').format('DD/MMM'),
            moment().format('DD/MMM')
        ]
      } else {
         labels = [
            moment().subtract(6, 'days').format('DD/MM/YYYY'),
            moment().subtract(5, 'days').format('DD/MM/YYYY'),
            moment().subtract(4, 'days').format('DD/MM/YYYY'),
            moment().subtract(3, 'days').format('DD/MM/YYYY'),
            moment().subtract(2, 'days').format('DD/MM/YYYY'),
            moment().subtract(1, 'days').format('DD/MM/YYYY'),
            moment().format('DD/MM/YYYY')
          ]
      }

      let config = {
        type: 'line',
        data: {
          labels: labels,
          datasets: [{
            label: (this.mensal)? "Saldo Utilizado":"Quantidade de requisições",
            backgroundColor: '#1d82e0',
            borderColor: '#1d82e0',
            data: this.ultimosRequests.reverse(),
            fill: false,
          }]
        },
        options: {
          title: {
            display: (this.mensal),
            text: "Histórico de uso nos últimos 30 dias"
          },
          elements: {
            line: {
              tension: 0.000001
            }
          },
          responsive: true,
          legend: {
            display: false
          },
          tooltips: {
            displayColors: false,
            callbacks:{
              label: (this.mensal) ? function(tooltipItem,data){
                var label = data.datasets[tooltipItem.datasetIndex].label || '';

                if (label){
                  label+=' R$ ';
                }
                label += tooltipItem.yLabel.toLocaleString('pt-BR');
                return label;
              } : (tooltipItem,data) => data.datasets[tooltipItem.datasetIndex].label +' '+ tooltipItem.yLabel
            }
          },
          hover: {
            mode: 'nearest',
            intersect: true
          },
          scales: {
            xAxes: [{
              display: true
            }],
            yAxes: [{
              display: true,
              ticks: {
                callback: (this.mensal)? function(value, index, values) {
                        return 'R$ ' + value;
                    } : (value, index, values) => ' ' + value,
                min: 0,
                max: Math.floor(max + 2),
                // forces step size to be 5 units
                stepSize: max >= 5 ? Math.floor(max/5) : 1
              }
            }]
          }
        }
      };

      this.chart = new Chart(this.ctx, config);
    }
  }
</script>
